import * as angular from 'angular';

import {
  Input,
  Inject,
  OnInit,
  Directive,
} from 'ng-metadata/core';

import { CartService } from 'services/cart.service';
import { OrderService } from 'services/order.service';
import { SearchService } from 'services/search.service';
import { SessionService } from 'services/session.service';
import { EcommerceService } from 'services/ecommerce.service';



/**
 * Order confirmation progress animation, dissapears after a time
 */
@Directive({
  selector: '[gw-checkout-confirmation-progress]',
})
export class CheckoutConfirmationProgressDirective {
  public fbq = (<any>window).fbq;
  public cart = (<any>window).GW.cart;
  public LC_API = (<any>window).LC_API;

  // Grab processed order already fetched on server
  public processedOrder = (<any>window).GW.processedOrder;

  public clientUrl: string;
  public percent = 0;
  public progress = {
    step: 1,
    finished: false,
  };

  constructor(
    @Inject('$filter') private $filter,
    @Inject('$interval') private $interval,
    @Inject('$element') private $element,
    @Inject(CartService) private cartService: CartService,
    @Inject(OrderService) private orderService: OrderService,
    @Inject(SearchService) private searchService: SearchService,
    @Inject(SessionService) private sessionService: SessionService,
    @Inject(EcommerceService) private ecommerceService: EcommerceService,
  ) { }

  /**
   * Component init hook
   */
  ngOnInit() {
    // Start progress bar
    this.startProgress();

    // Build force-login client URL
    const authToken = this.processedOrder.order_token;
    const customerId = this.processedOrder.customer.uuid;

    // Generate client app forced login
    this.clientUrl = `${process.env.MIX_API}/auth/token/${authToken}/${customerId}`;

    // Send conversion
    this.sendConversion();

    // Send ecommerce purchase
    this.ecommercePurchase();

    // Reset state back to empty
    this.searchService.resetSearch();
    this.orderService.resetOrder();
  }

  startProgress() {
    let second = 0;
    const $steps = this.$element.find('.js-confirmation-steps li');

    const interval = this.$interval(
      () => {
        second += 1;

        switch (second) {
          case 3:
            $steps.eq(0).addClass('is-completed');
            break;
          case 6:
            $steps.eq(1).addClass('is-completed');
            break;
          case 9:
            $steps.eq(2).addClass('is-completed');
            break;
          case 12:
            $steps.eq(3).addClass('is-completed');
            break;
        }

        if (second === 15) {
          this.$element.fadeOut();
          this.$interval.cancel(interval);
        }
      },
      1000,
    );
  }

  // Send conversion to GTM
  sendConversion() {
    this.ecommerceService.conversion(this.processedOrder.order_number, this.processedOrder.total);

    // Send purchase event to Facebook Pixel
    if (typeof this.fbq === 'function') {
      this.fbq('track', 'Purchase', {
        value: this.processedOrder.total,
        currency: 'USD',
      });
    }
  }

  ecommercePurchase() {
    const shipping = this.totalShippingCost();

    // Send conversion to GTM
    const purchaseData = {
      id: this.processedOrder.order_number,
      revenue: this.processedOrder.total,
      affiliation: this.processedOrder.source,
      shipping: this.$filter('number')(shipping, 2),
    };

    this.ecommerceService.purchase(purchaseData, this.cart);
  }

  totalShippingCost() {
    let shipping = 0;

    this.cart.order.forEach((orderItem) => {
      shipping += this.cartService.getShippingTotal(orderItem);
    });

    return shipping;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/confirmation/confirmation.directive.ts